import { render, staticRenderFns } from "./SimpleFlexRow.vue?vue&type=template&id=4c882f25&"
import script from "./SimpleFlexRow.vue?vue&type=script&lang=js&"
export * from "./SimpleFlexRow.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFlexRow.vue?vue&type=style&index=0&id=4c882f25&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports